module.exports = __webpack_public_path__ + "img/waiting.f2d4a2f1.png";